module.exports = __webpack_public_path__ + "img/io+sp.a25e6c5c.png";